import { useState, useRef, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Mail, Phone, ChevronDown } from "lucide-react";
import { FaLinkedinIn, FaWhatsapp, FaInstagram } from "react-icons/fa";

const Header = ({ language, setLanguage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const desktopRef = useRef(null);
const mobileRef = useRef(null);

 useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      desktopRef.current &&
      !desktopRef.current.contains(event.target) &&
      mobileRef.current &&
      !mobileRef.current.contains(event.target)
    ) {
      setLangOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () =>
    document.removeEventListener("mousedown", handleClickOutside);
}, []);
  /* 🔥 Dynamic Navbar Based On Language */
  const navItems =
    language === "CN"
      ? [
          { name: "首页", path: "/" },
          { name: "关于我们", path: "/about" },
          { name: "服务", path: "/services" },
            { name: "我们的团队", path: "/team" },
          { name: "保持联系", path: "/events" },
          { name: "职业", path: "/career" },
          { name: "联系我们", path: "/contact" },
        ]
      : [
          { name: "Home", path: "/" },
          { name: "About Us", path: "/about" },
           { name: "Services", path: "/services" },
           { name: "Meet Our Team", path: "/team" },
          { name: "Stay Connected", path: "/events" },
          { name: "Careers", path: "/career" },
          { name: "Contact Us", path: "/contact" },
        ];

  return (
    <>
      {/* ===== TOP BAR ===== */}
      <div className="hidden md:block bg-[#154059] text-white text-sm relative z-50">
        <div className="max-w-[1280px] mx-auto px-6 py-2 flex justify-between items-center">

          {/* Left Contact */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <Mail size={16} />
              <span>info@jtgroup.com.sg</span>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={16} />
              <span>+65 6123 4567</span>
            </div>
          </div>

          {/* Right Side */}
          <div className="flex items-center gap-6 relative">

            {/* Social Icons */}
        <div className="flex items-center gap-3">

  <Link to="/" className="text-white hover:text-[#c69c6d] transition">
    <FaLinkedinIn size={20} />
  </Link>

  <a
    href="https://wa.me/919999999999"
    target="_blank"
    rel="noopener noreferrer"
    className="text-white hover:text-[#25D366] transition"
  >
    <FaWhatsapp size={20} />
  </a>

  <Link to="/" className="text-white hover:text-[#c69c6d] transition">
    <FaInstagram size={20} />
  </Link>

</div>

            {/* Language Dropdown */}
         <div className="relative" ref={desktopRef}>

  <button
    onClick={() => setLangOpen(!langOpen)}
    className="flex items-center gap-2 text-white hover:text-[#C69C6D]"
  >
    {language === "CN" ? (
      <>
        <img src="https://flagcdn.com/w20/cn.png" className="w-4 h-4" />
        中文
      </>
    ) : (
      <>
        <img src="https://flagcdn.com/w20/gb.png" className="w-4 h-4" />
        English
      </>
    )}

    <ChevronDown size={16} />
  </button>


  {langOpen && (
    <div className="absolute right-0 mt-3 w-40 bg-[#EBEBEB] text-[#154059] shadow-xl rounded-md overflow-hidden">


      {/* EN */}
      <div
        onClick={() => {
          setLanguage("EN");
          setLangOpen(false);
        }}
        className={`px-4 py-2 flex items-center gap-2 cursor-pointer
        ${
          language === "EN"
            ? "bg-[#C69C6D] text-white"
            : "hover:bg-gray-100"
        }`}
      >
        <img src="https://flagcdn.com/w20/gb.png" className="w-4 h-4" />
        English
      </div>


      {/* CN */}
      <div
        onClick={() => {
          setLanguage("CN");
          setLangOpen(false);
        }}
        className={`px-4 py-2 flex items-center gap-2 cursor-pointer
        ${
          language === "CN"
            ? "bg-[#C69C6D] text-white"
            : "hover:bg-gray-100"
        }`}
      >
        <img src="https://flagcdn.com/w20/cn.png" className="w-4 h-4" />
        中文
      </div>

    </div>
  )}

</div>

          </div>
        </div>
      </div>

      {/* ===== MAIN HEADER ===== */}
      <header className="bg-white shadow-sm relative z-40">
        <div className="max-w-[1280px] mx-auto px-6 py-4 flex justify-between items-center">

          {/* Logo */}
          <Link to="/">
            <img
              src="/assets/images/JT Group Logo Design.png"
              alt="Logo"
              className="h-14"
            />
          </Link>

          {/* Desktop Menu */}
          <nav className="hidden lg:flex items-center gap-8 text-[#154059] font-medium text-[15px]">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  isActive
                    ? "text-[#C69C6D] font-semibold"
                    : "hover:text-[#C69C6D]"
                }
              >
                {item.name}
              </NavLink>
            ))}
          </nav>

          {/* Desktop Button */}
          <div className="hidden lg:block">
            <Link
              to="/contact"
              className="bg-[#C2976C] text-white px-8 py-3 font-semibold hover:bg-[#a88257] transition-colors duration-300"
            >
              {language === "CN" ? "联系我们" : "Get In Touch"}
            </Link>
          </div>

          {/* Mobile Menu Button */}
         {/* Mobile Right Side */}
<div className="flex items-center gap-2 lg:hidden">

  {/* Language mobile */}
  <div className="relative" ref={mobileRef}>

    <button
      onClick={() => setLangOpen(!langOpen)}
      className="flex items-center gap-2 bg-white text-black px-3 py-1 rounded border-[1px] border-black"
    >
      {language === "CN" ? (
        <>
          <img
            src="https://flagcdn.com/w20/cn.png"
            className="w-4 h-4"
          />
         CN
        </>
      ) : (
        <>
          <img
            src="https://flagcdn.com/w20/gb.png"
            className="w-4 h-4"
          />
          EN
        </>
      )}

      <ChevronDown size={16} />
    </button>

    {langOpen && (
      <div className="absolute right-0 mt-2 w-40 bg-[#EBEBEB] shadow rounded-md overflow-hidden">

        <div
      onClick={() => {
        setLanguage("EN");
        setLangOpen(false);
      }}
      className={`px-4 py-2 flex items-center gap-2 cursor-pointer
        ${
          language === "EN"
            ? "bg-[#C69C6D] text-white"
            : "hover:bg-gray-200"
        }`}
    >
      <img
        src="https://flagcdn.com/w20/gb.png"
        className="w-4 h-4"
      />
      English
    </div>

           <div
      onClick={() => {
        setLanguage("CN");
        setLangOpen(false);
      }}
      className={`px-4 py-2 flex items-center gap-2 cursor-pointer
        ${
          language === "CN"
            ? "bg-[#C69C6D] text-white"
            : "hover:bg-gray-200"
        }`}
    >
      <img
        src="https://flagcdn.com/w20/cn.png"
        className="w-4 h-4"
      />
      中文
    </div>

      </div>
    )}

  </div>

  {/* Menu Button */}
  <button
    className="text-[#154059]"
    onClick={() => setIsOpen(true)}
  >
    <Menu size={28} />
  </button>

</div>
        </div>

        {/* Overlay */}
        {isOpen && (
          <div
            className="fixed inset-0 bg-black/40 z-40"
            onClick={() => setIsOpen(false)}
          ></div>
        )}

        {/* Mobile Slide Menu */}
        <div
          className={`fixed top-0 left-0 h-full w-72 bg-white shadow-lg z-50 transform transition-transform duration-300 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex justify-between items-center px-6 py-4 border-b">
            <img
              src="/assets/images/1832a5e2849171ad6ad50551a93c28091a9773fa.png"
              alt="Logo"
              className="h-10"
            />
            <button onClick={() => setIsOpen(false)}>
              <X size={24} />
            </button>
          </div>

          <nav className="flex flex-col p-6 gap-5 text-[#154059] font-medium">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  isActive
                    ? "text-[#C69C6D] font-semibold"
                    : "hover:text-[#C69C6D]"
                }
              >
                {item.name}
              </NavLink>
            ))}

            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              className="mt-4 bg-[#C69C6D] text-white px-5 py-3 text-center"
            >
              {language === "CN" ? "联系我们" : "Get In Touch"}
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;